"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _goods = require("@/api/marketingFunction/superSubsidyV2/goods");
var _activity = require("@/api/marketingFunction/superSubsidyV2/activity");
var _stat = require("@/api/marketingFunction/superSubsidyV2/stat");
var _GoodsInfoCell = _interopRequireDefault(require("./components/GoodsInfoCell.vue"));
var _GoodsFormDialog = _interopRequireDefault(require("./components/GoodsFormDialog.vue"));
var _StockDialog = _interopRequireDefault(require("./components/StockDialog.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 商品列表查询条件（默认只看上架商品）
function createQueryData() {
  return {
    title: '',
    activityId: null,
    goodsStatus: 1,
    saleStatus: null,
    page: 1,
    size: 20
  };
}
var _default = exports.default = {
  name: 'SuperSubsidyV2Goods',
  components: {
    GoodsInfoCell: _GoodsInfoCell.default,
    GoodsFormDialog: _GoodsFormDialog.default,
    StockDialog: _StockDialog.default
  },
  data: function data() {
    return {
      queryData: createQueryData(),
      total: 0,
      tableData: [],
      tableLoading: false,
      activityOption: [],
      statData: {},
      eventsType: 'add',
      // add 新增 / edit 编辑
      editDetail: null,
      // 编辑态商品详情，弹窗据此回填
      dialogVisible: false,
      stockRow: null,
      // 库存调整目标行
      stockVisible: false,
      deleting: false,
      statusLoading: false,
      listSeq: 0 // 列表取数序号：仅最新一次请求可写入表格，丢弃过期响应
    };
  },
  computed: {
    // 累计补贴金额展示：两位小数 + 千分位（如 3,926.28）
    subsidyAmtTotalText: function subsidyAmtTotalText() {
      return (Number(this.statData.subsidyAmtTotal) || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  created: function created() {
    this.getGoodsList();
    this.getActivityOption();
    this.getStatSummary();
  },
  methods: {
    // 累计统计：累计补贴金额与累计出单笔数（数据源为已核销记录）
    getStatSummary: function () {
      var _getStatSummary = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _stat.statSummary)({});
            case 1:
              res = _context.v;
              this.statData = res.data || {};
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getStatSummary() {
        return _getStatSummary.apply(this, arguments);
      }
      return getStatSummary;
    }(),
    // 所属活动筛选项
    getActivityOption: function () {
      var _getActivityOption = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _activity.activitySelect)({});
            case 1:
              res = _context2.v;
              this.activityOption = res.data || [];
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getActivityOption() {
        return _getActivityOption.apply(this, arguments);
      }
      return getActivityOption;
    }(),
    // 商品分页查询
    getGoodsList: function () {
      var _getGoodsList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var seq, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              seq = ++this.listSeq;
              _context3.p = 1;
              this.tableLoading = true;
              _context3.n = 2;
              return (0, _goods.goodsList)((0, _objectSpread2.default)({}, this.queryData));
            case 2:
              res = _context3.v;
              if (!(seq !== this.listSeq)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              this.tableData = res.data.data || [];
              this.total = res.data.total || 0;
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.log(_t3);
            case 5:
              _context3.p = 5;
              if (seq === this.listSeq) {
                this.tableLoading = false;
              }
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 4, 5, 6]]);
      }));
      function getGoodsList() {
        return _getGoodsList.apply(this, arguments);
      }
      return getGoodsList;
    }(),
    // 查询：回到第一页
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.getGoodsList();
    },
    // 重置查询条件并刷新
    onInitialize: function onInitialize() {
      this.queryData = createQueryData();
      this.getGoodsList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.getGoodsList();
    },
    // 页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.getGoodsList();
    },
    // 上下架切换：确认后提交，取消或失败回滚开关
    onStatusChange: function onStatusChange(row) {
      var _this = this;
      if (this.statusLoading) {
        row.goodsStatus = row.goodsStatus === 1 ? 0 : 1;
        return;
      }
      var isOff = row.goodsStatus === 0;
      this.$confirm("\u786E\u8BA4".concat(isOff ? '下架' : '上架', "\u5F53\u524D\u5546\u54C1?"), '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this.statusLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _goods.goodsStatus)({
                id: row.id,
                goodsStatus: row.goodsStatus
              });
            case 2:
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this.getGoodsList();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.log(_t4);
              row.goodsStatus = isOff ? 1 : 0;
            case 4:
              _context4.p = 4;
              _this.statusLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3, 4, 5]]);
      }))).catch(function () {
        row.goodsStatus = isOff ? 1 : 0;
      });
    },
    // 新增：清掉上次的编辑详情，按初始值打开弹窗
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.editDetail = null;
      this.dialogVisible = true;
    },
    // 先取详情再开弹窗：编辑回填数据未取到时不展示空表单
    onEdit: function () {
      var _onEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(row) {
        var res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _goods.goodsDetail)({
                id: row.id
              });
            case 1:
              res = _context5.v;
              this.eventsType = 'edit';
              this.editDetail = res.data || {};
              this.dialogVisible = true;
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function onEdit(_x) {
        return _onEdit.apply(this, arguments);
      }
      return onEdit;
    }(),
    // 打开库存调整弹窗（弹窗内按行数据初始化）
    onStockAdjust: function onStockAdjust(row) {
      this.stockRow = row;
      this.stockVisible = true;
    },
    // 删除：确认后提交并刷新列表
    onDelete: function onDelete(row) {
      var _this2 = this;
      if (this.deleting) return;
      this.$confirm('是否确认删除此商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _this2.deleting = true;
              _context6.p = 1;
              _context6.n = 2;
              return (0, _goods.goodsDelete)({
                id: row.id
              });
            case 2:
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.getGoodsList();
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              console.log(_t6);
            case 4:
              _context6.p = 4;
              _this2.deleting = false;
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, null, [[1, 3, 4, 5]]);
      }))).catch(function () {});
    }
  }
};